// extracted by mini-css-extract-plugin
export default {"container":"yda-z","heading":"zda-z","links":"Ada-z","linkBtn":"Bda-z","disabled":"Cda-z","linkUppercaseBold":"Dda-z","copy":"Eda-z","subCopy":"Fda-z"};